import { colors } from '@thndr/design-system';
import styled from 'styled-components';

import theme from '@/theme';

// Fixed so elements positioned against the header can offset by it.
export const BANNER_HEIGHT = 40;

export const Container = styled.div<{ withHeaderOffset: boolean }>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: ${BANNER_HEIGHT}px;
  background: ${colors.grey10};
  border-bottom: 1px solid ${colors.blue60};
  border-radius: 2px;
  width: 100%;
  padding: 0 9px;
  ${(props) =>
    props.withHeaderOffset &&
    `
    position: fixed;
    top: ${theme.headerHeight}px;
    left: 0;
    z-index: 10;
  `}
`;

export const Content = styled.div`
  width: 85%;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Paragraph = styled.p`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 13.8px;
  word-break: keep-all;
  color: ${colors.black};
  text-align: start;
  margin: 0;
`;

export const Link = styled.a`
  font-weight: 600;
  font-size: 14px;
  text-decoration: underline;
  color: ${colors.blue60};
`;
